import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import ProductDetailsPopup from './ProductPopup';
import theme from '../../theme';

export default function ProductTemp({ product,index }) {
  const [showPopup, setShowPopup] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleAddCart = () => {
    setSelectedProduct(product);
    setShowPopup(true);
  };

  const closePopup = () => setShowPopup(false);

  return (
    <>
      <div key={product.id} className="col-md-12 mb-1">
        <div
          className="d-flex justify-content-between align-items-start p-3 mt-1 rounded-3"
          style={{ backgroundColor: product?.isStock ? "white" : "#ffe0b2" }}
        >
          <div className="flex-grow-1">
            <span
              className="fw-semibold text-break d-block title"
              style={{
                fontSize: "15px",
                wordWrap: "break-word",
                whiteSpace: "normal",
              }}
            >
              {product?.title} 
              {/* ({product?.code}) */}
            </span>
            <p className="mb-0 price" style={{ fontSize: "14px" }}>
              <span className="text-dark me-2 ">
                Selling price:{" "}
                <span
                  className="fw-semibold"
                  style={{ color: theme.palette.indigo.dark }}
                >
                  ₹{product?.baseprice}
                </span>
              </span>
              <span className=" ms-1">
                MRP :₹{product?.mrp}
              </span>
            </p>
          </div>

    {/* Right-Side Section (Button or Out of Stock) */}
      <div style={{ flexShrink: 0, display: "flex", alignItems: "center" }}>
        {product?.isStock ? (
          <button
            className="btn ms-2 addbtnhover"
            style={{
              backgroundColor: theme.palette.indigo.lighter,
              color: theme.palette.indigo.main,
            }}
            onClick={handleAddCart}
          >
            <FontAwesomeIcon icon={faPlus} />
          </button>
        ) : (
          <div
            className="rounded p-1 text-center"
            style={{
              fontSize: "12px",
              color: "red",
              border: "1px solid red",
              whiteSpace: "nowrap", // Prevents multi-line wrapping
              minWidth: "80px", // Ensures width stays consistent
            }}
          >
            Out of Stock
          </div>
            )}
          </div>
        </div>
      </div>


      {showPopup && (
        <ProductDetailsPopup index={index}  key={selectedProduct._id} product={selectedProduct} onClose={closePopup} />
      )}
    </>
  );
}
